
import { LabOrder } from '../../shared/data/lab-order';
import { LabOrderBusinessService } from '../../shared/lab-order-business.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {

  @Input() labOrder: LabOrder;
  labOrderNumber: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/modify-order/invoice/invoice.component.ts